import axios from 'axios'
import moment from 'moment'
import S3 from 'aws-sdk/clients/s3'
import AWS from 'aws-sdk'
import { v4 as uuidv4 } from 'uuid'
import { notification } from 'antd'

/* config upload S3 */
const wasabiEndpoint = new AWS.Endpoint(process.env.REACT_APP_S3_URL)
const ENDPOINT_URL_IMAGE = `${process.env.REACT_APP_S3_URL}/admin-order/`
const upload = new S3({
  endpoint: wasabiEndpoint,
  region: process.env.REACT_APP_REGION,
  accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
})
/* config upload S3 */

export const uploadFile = async (file) => {
  try {
    const _d = moment(new Date()).format('YYYY/MM/DD') + '/' + uuidv4()

    if (!file) return ''

    let fileName = file.name.split('.')
    const fileNameUpload = _d + '/' + fileName.toString().replaceAll(',', '.')

    const res = await upload
      .putObject({
        Body: file,
        Bucket: process.env.REACT_APP_BUCKET_NAME,
        Key: fileNameUpload,
        ACL: 'public-read',
      })
      .promise()

    if (res.$response.httpResponse.statusCode !== 200) {
      notification.error({ message: 'Upload file có lỗi, vui lòng thử lại' })
      return ''
    }

    return 'https://' + ENDPOINT_URL_IMAGE + fileNameUpload
  } catch (error) {
    console.log(error)
    return ''
  }
}

export const uploadFilePDF = async (file) => {
  try {
    const _d = moment(new Date()).format('YYYY/MM/DD') + '/' + uuidv4()

    if (!file) return ''

    let fileName = file.name.split('.')
    const fileNameUpload = _d + '/' + fileName.toString().replaceAll(',', '.')

    const res = await upload
      .putObject({
        Body: file,
        Bucket: process.env.REACT_APP_BUCKET_NAME,
        Key: fileNameUpload,
        ACL: 'public-read',
        ContentDisposition: "inline",
        ContentType: "application/pdf"
      })
      .promise()

    if (res.$response.httpResponse.statusCode !== 200) {
      notification.error({ message: 'Upload file có lỗi, vui lòng thử lại' })
      return ''
    }

    return 'https://' + ENDPOINT_URL_IMAGE + fileNameUpload
  } catch (error) {
    console.log(error)
    return ''
  }
}

export const uploadFiles = async (files) => {
  try {
    const _d = moment(new Date()).format('YYYY/MM/DD') + '/' + uuidv4()

    if (!files) return false

    let arrayFileName = []
    const promises = files.map(async (file) => {
      let fileName = file.name.split('.')
      const fileNameUpload = _d + '/' + fileName.toString().replaceAll(',', '.')

      arrayFileName.push(fileNameUpload)

      const res = upload
        .putObject({
          Body: file,
          Bucket: process.env.REACT_APP_BUCKET_NAME,
          Key: fileNameUpload,
          ACL: 'public-read',
        })
        .promise()

      return res
    })

    const responses = await Promise.all(promises)
    for (let i = 0; i < responses.length; i++) {
      if (responses[i].$response.httpResponse.statusCode !== 200) {
        notification.error({ message: 'Upload file có lỗi, vui lòng thử lại' })
        return false
      }
    }

    let listUrl = arrayFileName.map((name) => 'https://' + ENDPOINT_URL_IMAGE + name)
    return listUrl || false
  } catch (error) {
    console.log(error)
    return false
  }
}
